<template>
    <div class="flex gap-x-1 py-0.5">
        <UAvatar :src="comment.photoUrl" :alt="comment.createdBy" />
        <div class="w-72">
            <div class="flex">
                <span class="flex gap-x-1 align-baseline">
                    <b class="mr-1 truncate w-32">{{ comment.createdBy }}</b>
                </span>
                <span class="text-xs">({{ formatDateTimeCompact(comment.createdAt) }})</span>
            </div>

            <div>{{ comment.body }}</div>
        </div>
        <UCheckbox
            v-if="thread"
            :model-value="thread.resolved"
            @update:model-value="emit('toggleResolveThread', thread)"
            @click.stop
        />
    </div>
</template>

<script setup lang="ts">

import {CommentThread, ResourceLinkComment} from '@/comment/comment.service'
import {formatDateTimeCompact} from '@/services/formatter.service'

defineProps({
    comment: {
        type: Object as () => ResourceLinkComment,
        required: true
    },
    thread: {
        type: Object as () => CommentThread,
        required: false,
    }
})

const emit = defineEmits(['toggleResolveThread'])

</script>

<style scoped>

</style>